import { makeStyles } from '@material-ui/core/styles';

import { draftModalActionButton } from '../policy-drafting.styles';

export default makeStyles((theme) => ({
  dialog: {
    width: 580
  },
  body: {
    display: 'block',
    marginTop: theme.spacing(4),
    color: theme.colorPalette.green_100
  },
  reason: {
    marginTop: theme.spacing(4)
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    marginTop: theme.spacing(4),
    padding: theme.spacing(2, 4),
    borderRadius: 4,
    backgroundColor: theme.colorPalette.beige_50
  },
  warning: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  warningText: {
    color: theme.colorPalette.green_100
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  actionButton: draftModalActionButton(theme)
}));
